import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import * as S from '@/components/Ad/Promotions/PromotionFlow.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const PromotionFlowSubtitle: React.FC<{
  type: 'vip' | 'premium';
}> = ({ type }) => {
  const { t } = useTranslation();
  const isPremium = type === 'premium';
  const theme = useTheme();

  return (
    <S.Subtitle>
      <Typography.Body
        $variant="1"
        data-testid={AdPageTestIds.promotionFlow.subheader.subtitle}
      >
        {t(`pages.ad.make_${type}_subtitle`)}
      </Typography.Body>

      <S.SubtitleBonus>
        <S.SubtitleBonusRow>
          <S.SubtitleBonusText
            data-testid={AdPageTestIds.promotionFlow.subheader.row1Text}
          >
            {t('common.earlier')}
          </S.SubtitleBonusText>
          <S.SubtitleBonusMessageOld
            data-testid={AdPageTestIds.promotionFlow.subheader.row1Message}
          >
            {t('pages.ad.up_one_time', {
              plusVip: isPremium ? ` + ${t('pages.ad.vip')}` : '',
            })}
          </S.SubtitleBonusMessageOld>
        </S.SubtitleBonusRow>

        <S.SubtitleBonusRow>
          <S.SubtitleBonusText
            data-testid={AdPageTestIds.promotionFlow.subheader.row2Text}
          >
            {t('common.now')}
          </S.SubtitleBonusText>
          <S.SubtitleBonusMessage
            data-testid={AdPageTestIds.promotionFlow.subheader.row2Message}
          >
            <IconBox $filename="upload-green.svg" $width={15} $height={13} />
            {t('pages.ad.up_every_day')}
            {isPremium && (
              <>
                {' + '}
                <IconBox $filename="vip.svg" $width={15} $height={13} />
                {t('pages.ad.vip')}
              </>
            )}
          </S.SubtitleBonusMessage>
        </S.SubtitleBonusRow>

        <S.SubtitleBonusLabel
          $bgColor={theme.palette.brand[`${type}1`]}
          data-testid={AdPageTestIds.promotionFlow.bonusLabel}
        >
          {t('common.bonus')}
        </S.SubtitleBonusLabel>
      </S.SubtitleBonus>
    </S.Subtitle>
  );
};
